import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaArrowRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const EventSingle = () => {

  // Get Event details passed via router state
  const location = useLocation();
  const event = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={event.title} page={"Event Single"} />

      <section className='event-single page-single'>

        <div className='event-info page-info'>

          {/* Event Image */}
          <div className='image'>
            <img src={event.image} alt={event.title} />
          </div>

          <div className='content'>

            {/* Event Title */}
            <h3 className='main-heading'>{event.title}</h3>

            {/* Event Description */}
            {event.overviews.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Event Image Gallery */}
            <Lightbox images={event.gallery} />

            {/* Key Features */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Key Features:</h3>
              <p>A glimpse into the standout highlights and memorable elements that defined the {event.title} celebration:</p>

              {/* Features List */}
              <ul>
                {event.features.map((feature, index) => {
                  return <li key={index}> <div className='icon'><FaCheck  /></div> {feature}</li>
                })}
              </ul>

            </div>

            {/* Customization Options */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Customization Options:</h3>
              <p>Discover how we tailored every detail of the {event.title} event to reflect the couple’s style, preferences, and unique love story.</p>

              {/* Options List */}
              <ul>
                {event.customizations.map((customization, index) => {
                  return <li key={index}> <div className='icon'><FaCircleNotch  /></div> {customization}</li>
                })}
              </ul>

            </div>

            {/* Event Highlights */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Event Highlights:</h3>
              <p>Unforgettable moments and special experiences that made the {event.title} celebration truly exceptional.</p>

              {/* Highlights List */}
              <ul>
                {event.highlights.map((highlight, index) => {
                  return <li key={index}> <div className='icon'><FaArrowRight /></div> {highlight}</li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Event details */}
        <PageSidebar
          heading={'Event'}
          details={event.details}
        />

      </section>

    </> 
  );
}

export default EventSingle;